<div
  fxLayout="row"
  fxLayoutAlign="start center"
  class="u-marginBottom-8 u-padding-8-0"
>
  <p
    i18n="@@profileView.icebreakers.title"
    fxFlex="calc(100% - 40px)"
    class="text-subtitle-1"
  >
    {{ profile.first_name }}'s Icebreakers
  </p>
  <div
    *ngIf="profile.icebreakers?.length && isUser"
    fxFlex="40px"
    fxLayout="row"
    fxLayoutAlign="end start"
  >
    <button
      i18n="@@global.edit"
      class="c-button color-blue u-textDecoration-underline--hover"
      (click)="openEditDialog()"
    >
      Edit
    </button>
  </div>
</div>
<ng-container *ngIf="isUser && !profile.icebreakers?.length">
  <div
    class="u-marginBottom-16 color-grey bg-color-teal-50 u-padding-16 u-borderRadius--4px"
    fxLayout="row"
    fxLayoutGap="8px"
  >
    <div>
      <mat-icon>info_outline</mat-icon>
    </div>
    <p
      i18n="@@profileView.icebreakers.infoLabel"
      [ngStyle]="{ 'padding-top': '2px' }"
    >
      Add profile icebreakers to get better introductions and conversations. 🙌
    </p>
  </div>
  <div
    fxLayout="column"
    fxLayout.gt-sm="row"
    fxLayoutGap="2%"
    class="u-marginBottom-16"
  >
    <button
      *ngFor="let index of [1, 2, 3]"
      class="u-border-grey300 u-borderRadius--4px u-padding-8 c-button u-display-block"
      [ngStyle]="{ 'border-style': 'dashed' }"
      fxFlex.gt-sm="31%"
      (click)="openEditDialog()"
      appTrackClick
      [elementCustomId]="'profile-icebreaker-placeholder-' + index"
    >
      <p
        i18n="@@profileView.icebreakers.selectLabel"
        class="mat-caption u-marginBottom-8 color-grey-300"
      >
        Select an icebreaker
      </p>
      <p i18n="@@profileView.icebreakers.writeLabel" class="color-grey-300">
        And write your own answer
      </p>
    </button>
  </div>
  <div class="u-textAlign-center">
    <button
      i18n="@@profileView.icebreakers.add.buttonLabel"
      mat-raised-button
      color="primary"
      (click)="openEditDialog()"
      appTrackClick
      elementCustomId="profile-icebreaker-add-btn"
    >
      Add icebreakers
    </button>
  </div>
</ng-container>
<ng-container *ngIf="profile.icebreakers?.length">
  <div
    fxLayout="column"
    fxLayout.gt-sm="row"
    fxLayoutGap="2%"
    class="u-marginBottom-16"
  >
    <div
      *ngFor="
        let icebreaker of profile.icebreakers | slice: 0 : 3;
        let index = index
      "
      class="u-border-grey100 u-borderRadius--4px u-paddingTop-8 u-padding-0-8 u-paddingBottom-16"
      fxFlex.gt-sm="31%"
      fxLayout="column"
    >
      <div fxFlex="1 1 auto" class="u-marginBottom-16">
        <p class="mat-caption u-marginBottom-8 color-grey-300">
          <ng-container
            i18n="@@global.icebreakerDefaultQuestion"
            >{icebreaker?.question, select, other {{{ icebreaker?.question }}}
          }</ng-container>
        </p>
        <p class="u-text-maxWidth u-wordWrap-breakWord">
          {{ icebreaker.answer }}
        </p>
      </div>
      <div
        *ngIf="!isUser && (tenant | async)?.enabled_features?.conversations"
        class="u-textAlign-center"
      >
        <button
          i18n="@@profileView.icebreakers.startConversation.buttonLabel"
          mat-stroked-button
          color="primary"
          (click)="openMessageDialog(icebreaker)"
          appTrackClick
          [elementCustomId]="
            'profile-icebreaker-startConversation-' + (index + 1)
          "
        >
          Send a message
        </button>
      </div>
    </div>
  </div>
</ng-container>
